module.exports = "/images/vendor/flag-icon-css/flags/4x3/sv.svg?1176ea281282d6b053af86809e32d6f9";